import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "action-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "fixed-btn",
      type: "primary",
      onClick: _ctx.onSave
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("保存")
      ])),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: "",
      "row-class-name": _ctx.rowClassName,
      class: "mt50"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          index: _ctx.tableIndex
        }, null, 8, ["index"]),
        _createVNode(_component_el_table_column, {
          prop: "admin_name",
          label: "总账号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "store_name",
          label: "门店"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "门店账号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "手机号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "role_name",
          label: "角色"
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "错误原因"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_tag, {
                onClick: ($event: any) => (_ctx.onDel(scope.row))
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("删除")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    _createVNode(_component_el_pagination, {
      onCurrentChange: _ctx.onCurrentChange,
      currentPage: _ctx.page,
      "page-size": _ctx.limit,
      layout: "total, prev, pager, next",
      total: _ctx.total
    }, null, 8, ["onCurrentChange", "currentPage", "page-size", "total"])
  ]))
}